module.exports = __webpack_public_path__ + "media/images/themes/mandy/9-5655784a0b92d2f32e2e7a37000d4443.jpg";